import type { OrderStatus, ProductLabelId, SiteConfig, StoreSettings } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'EMA CHARMS',
    tagline: 'Little Charms, Big Love',
    description: 'EMA CHARMS, butik boneka rajut handmade. Jelajahi butik 3D berisi amigurumi, boneka beruang, kelinci, gantungan kunci rajut, dan boneka custom, lalu pesan dengan mudah lewat WhatsApp.',
    url: getOrigin()
}

// The official logo, kept in the site's storage. Store settings can replace it from the admin dashboard.
export const DEFAULT_LOGO_URL = 'https://noble-marsh-2db.cdn.modulify.website/brand/ema-charms-logo.png'

export const DEFAULT_SETTINGS: StoreSettings = {
    id: null,
    storeName: 'EMA CHARMS',
    tagline: 'Little Charms, Big Love',
    subtagline: 'Handmade Crochet',
    description: 'EMA CHARMS adalah toko handmade yang menghadirkan berbagai boneka rajut (amigurumi), gantungan kunci rajut, dan produk kerajinan lucu yang dibuat dengan kreativitas, ketelitian, dan penuh cinta.',
    logo: DEFAULT_LOGO_URL,
    logoAlt: 'Logo EMA CHARMS',
    whatsappNumber: '',
    address: '',
    instagram: '',
    tiktok: '',
    facebook: ''
}

// Category slugs the 3D boutique and the home page build sections around.
export const LIMITED_CATEGORY = 'edisi-terbatas'
export const CUSTOM_CATEGORY = 'boneka-custom'

export const NAV_LINKS = [
    { href: '/', label: 'Butik' },
    { href: '/shop', label: 'Semua Produk' },
    { href: '/shop?label=edisi-terbatas', label: 'Edisi Terbatas' },
    { href: `/shop?category=${CUSTOM_CATEGORY}`, label: 'Boneka Custom' }
]

export const PRODUCT_LABELS: Array<{ id: ProductLabelId, label: string, short: string }> = [
    { id: 'terbaru', label: 'Produk Terbaru', short: 'Terbaru' },
    { id: 'terlaris', label: 'Produk Terlaris', short: 'Terlaris' },
    { id: 'edisi-terbatas', label: 'Edisi Terbatas', short: 'Edisi Terbatas' },
    { id: 'custom', label: 'Produk Custom', short: 'Custom' }
]

export const labelName = (id: ProductLabelId): string => PRODUCT_LABELS.find(entry => entry.id === id)?.short ?? id

export const PRICE_RANGES = [
    { id: 'under-100', label: 'Di bawah Rp 100.000', min: 0, max: 99999 },
    { id: '100-250', label: 'Rp 100.000 sampai 250.000', min: 100000, max: 250000 },
    { id: '250-400', label: 'Rp 250.001 sampai 400.000', min: 250001, max: 400000 },
    { id: 'over-400', label: 'Di atas Rp 400.000', min: 400001, max: null }
]

export const SORT_OPTIONS = [
    { id: 'featured', label: 'Unggulan' },
    { id: 'newest', label: 'Produk terbaru' },
    { id: 'price-asc', label: 'Harga termurah' },
    { id: 'price-desc', label: 'Harga termahal' },
    { id: 'name', label: 'Nama A sampai Z' }
]

export const ORDER_STATUSES: Array<{ id: OrderStatus, label: string }> = [
    { id: 'baru', label: 'Baru' },
    { id: 'diproses', label: 'Diproses' },
    { id: 'selesai', label: 'Selesai' },
    { id: 'dibatalkan', label: 'Dibatalkan' }
]
